import { CheckCircle2 } from "lucide-react";

/**
 * Small dashboard-style metric chip used to reinforce laboratory credibility,
 * e.g. Purity 99.8%, Batch Status Verified, COA Available.
 */
export default function LabMetricBadge({ label, value, verified = false, className = "" }) {
  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-xl border border-blue-100 bg-blue-50/60 px-3.5 py-2.5 ${className}`}
      data-testid={`lab-metric-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <span className="text-[11px] uppercase tracking-wider text-slate-500 font-medium">{label}</span>
      <span className="flex items-center gap-1 text-sm font-display font-bold text-brandblue-700">
        {verified && <CheckCircle2 className="h-3.5 w-3.5 text-brandblue-600" strokeWidth={1.5} />}
        {value}
      </span>
    </div>
  );
}
